var lists_default = {
  "fontElementMap": "BNlVa",
  "orderedlist": "S-9-b",
  "bulletedlist": "qMiL2",
  "listItem": "RiQ-A"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
